<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-join-class-school"
             @hidden="resetModal">
            <div class="container wrap-form-save-class-school">
                <h4>
                    <strong>Vào lớp học</strong>
                </h4>
                <b-form id="form-save-class-school" @submit.prevent="handleJoinSave">
                    <div class="modal__form__item display-block">
                        <div class="row">
                            <div class="col-md-4">
                                <label for="code">Nhập mã lớp:</label>
                            </div>
                            <div class="col-md-8">
                                <b-form-input id="code" v-model="form.code" type="text"   placeholder="Nhập mã lớp"
                                    autocomplete="off"
                                    class="form-control display-flex-center form-30h border-rd-20 font-sanpro-light" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.code.required && submitted">
                                    Vui lòng nhập mã lớp
                                </span>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="modal__form__item display-block">
                        <div class="row">
                            <div class="col-md-4">
                                <label for="password">Mật khẩu:</label>
                            </div>
                            <div class="col-md-8">
                                <b-form-input id="password" v-model="form.password" type="text"   placeholder="Nhập mật khẩu"
                                    autocomplete="off"
                                    class="form-control display-flex-center form-30h border-rd-20 font-sanpro-light" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.password.required && submitted">
                                    Vui lòng nhập mật khẩu
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form_action display-flex margin-top-20 justity-content-space-between">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            Tham gia lớp học
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>

    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import {joinMemberToClassSchoolService} from './../_api/classSchoolServices';
export default {
    name: "ModalJoinClassSchool",
    components: {
    },
    // watch: {
    //     classSchoolId(newval) {
    //         console.log(newval)
    //         if (newval > 0) {
    //             this.getDetailClassSchool()
    //         }
    //     }
    // },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                code:'',
                password:''
            }
        }
    },
    validations() {
        return {
            form: {
                code: {
                    required,
                },
                password: {
                    required,
                }
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    mounted() {
        this.handleShowModal()

    },

    methods: {
        handleJoinSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                this.form.code = this.form.code.trim()
                this.form.password = this.form.password.trim()

                joinMemberToClassSchoolService(this.form).then((res)=>{
                    if (res && res.data && !res.errors) {
                        if(res.data==1){
                            self.$toast.success('Tham gia lớp học thành công')
                            self.handleDone()
                        }else if(res.data==2){
                            //không tìm thấy lớp học
                            self.$toast.error('Không tìm thấy lớp học')
                        }
                        else{
                            self.$toast.error('Bạn đã tham gia lớp học rồi')
                        }
                    }
                })
            }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        resetModal() {
            
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-join-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-join-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-join-class-school'].show()
        },
    }
}
</script>

<style lang="scss" scoped>
.margin-top-20{
    margin-top: 20px !important;
}
.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>